const env = {
    BACKEND_URL: "https://sfinx.felk.cvut.cz/statistic-tool"
    //BACKEND_URL: "http://localhost:2001/statistic-tool"
};

export { env };